<template>
    <row justify="center">
        <column style="max-width: 1400px;" cols="full">
            <!--                     w-screen -translate-x-6, value must equal that of the outer container's padding in Home.vue   -->
            <row align="stretch" class="xs:overflow-auto xs:w-screen xs:transform xs:-translate-x-6 xs:pr-6" no-wrap>
                <column :key="index"
                        align="center"
                        cols="1/4"
                        style="position: relative; min-width: 130px;"
                        v-for="(item, index) in items"
                >
                    <divider style="position: absolute; top: 29px;" height="6" color="gray-300"></divider>
                    <div
                            class="bg-white w-1/2"
                            :class="{'left-0': index === 0, 'right-0': index === items.length - 1}"
                            style="height: 100%; position: absolute; top: 0; z-index: 1;"
                            v-if="index === 0 || index === items.length - 1"
                    ></div>
                    <card class="flex justify-center items-center"
                          color="white"
                          height="71"
                          round
                          style="z-index: 2;"
                          width="71"
                    >
                        <icon :icon="item.icon" color="primary" size="1x"></icon>
                    </card>
                    <div class="mt-3 text-center uppercase poppins-bold tracking-wide leading-relaxed text-secondary z-10"
                         v-html="item.text"
                    ></div>
                </column>
            </row>
        </column>
    </row>
</template>

<script>
    export default {
        name: "VirtualAssessment",
        props: {},
        components: {
            row: () => import('@/components/display/Row.vue'),
            // grid: () => import('@/components/display/Grid.vue'),
            // 'grid-cell': () => import('@/components/display/GridCell.vue'),
            card: () => import('@/components/Card.vue'),
            icon: () => import('@/components/display/Icon.vue'),
            divider: () => import('@/components/Divider.vue'),
            column: () => import('@/components/display/Col.vue'),
        },
        data: () => ({
            items: [
                {icon: 'puzzle', text: 'Ai . Enabled'},
                {icon: 'cloud-check', text: 'Cloud storage'},
                {icon: 'fingerprint', text: 'Secure identity <br> verification'},
                {icon: 'cellphone-link', text: 'mobile and <br> web-based'},
            ]
        }),
    }
</script>

<style scoped>

</style>